import api from "./api";

export interface StatisticsResponse {
  success: number;
  message: string;
  status: number;
}

export const statisticsService = {

  // Increase watch count
  async addWatchCount(id: string): Promise<StatisticsResponse> {
    try {
      const response = await api.put<StatisticsResponse>(
        `/clips/${id}/watch`
      );
      return response.data;
    } catch (error: unknown) {
      if (error && typeof error === "object" && "response" in error) {
        const axiosError = error as { response: { data: StatisticsResponse } };
        console.error("WATCH COUNT ERROR:", axiosError.response.data);
        return axiosError.response.data;
      } else {
        console.error("WATCH COUNT UNKNOWN ERROR:", String(error));
        throw error;
      }
    }
  },

  // Increase download count
  async addDownloadCount(id: string): Promise<StatisticsResponse> {
    try {
      const response = await api.put<StatisticsResponse>(
        `/clips/${id}/download`
      );
      return response.data;
    } catch (error: unknown) {
      if (error && typeof error === "object" && "response" in error) {
        const axiosError = error as { response: { data: StatisticsResponse } };
        console.error("DOWNLOAD COUNT ERROR:", axiosError.response.data);
        return axiosError.response.data;
      } else {
        console.error("DOWNLOAD COUNT UNKNOWN ERROR:", String(error));
        throw error;
      }
    }
  },

};